export type SupportedLanguageList = {
  id: string;
  label: {
    en: string;
    de: string;
  };
};

export const ALL_LANGUAGES_LIST = [
  {
    id: 'en',
    label: {
      en: 'English',
      de: 'Englisch',
    },
  },
  {
    id: 'es',
    label: {
      en: 'Spanish',
      de: 'Spanisch',
    },
  },
  {
    id: 'fr',
    label: {
      en: 'French',
      de: 'Französisch',
    },
  },
  {
    id: 'de',
    label: {
      en: 'German',
      de: 'Deutsch',
    },
  },
  {
    id: 'it',
    label: {
      en: 'Italian',
      de: 'Italienisch',
    },
  },
  {
    id: 'pt',
    label: {
      en: 'Portuguese',
      de: 'Portugiesisch',
    },
  },
  {
    id: 'ru',
    label: {
      en: 'Russian',
      de: 'Russisch',
    },
  },
  {
    id: 'zh',
    label: {
      en: 'Chinese',
      de: 'Chinesisch',
    },
  },
  {
    id: 'ja',
    label: {
      en: 'Japanese',
      de: 'Japanisch',
    },
  },
  {
    id: 'ko',
    label: {
      en: 'Korean',
      de: 'Koreanisch',
    },
  },
  {
    id: 'ar',
    label: {
      en: 'Arabic',
      de: 'Arabisch',
    },
  },
  {
    id: 'hi',
    label: {
      en: 'Hindi',
      de: 'Hindi',
    },
  },
  {
    id: 'bn',
    label: {
      en: 'Bengali',
      de: 'Bengalisch',
    },
  },
  {
    id: 'ur',
    label: {
      en: 'Urdu',
      de: 'Urdu',
    },
  },
  {
    id: 'vi',
    label: {
      en: 'Vietnamese',
      de: 'Vietnamesisch',
    },
  },
  {
    id: 'tr',
    label: {
      en: 'Turkish',
      de: 'Türkisch',
    },
  },
  {
    id: 'th',
    label: {
      en: 'Thai',
      de: 'Thailändisch',
    },
  },
  {
    id: 'nl',
    label: {
      en: 'Dutch',
      de: 'Niederländisch',
    },
  },
  {
    id: 'pl',
    label: {
      en: 'Polish',
      de: 'Polnisch',
    },
  },
  {
    id: 'sv',
    label: {
      en: 'Swedish',
      de: 'Schwedisch',
    },
  },
  {
    id: 'fi',
    label: {
      en: 'Finnish',
      de: 'Finnisch',
    },
  },
  {
    id: 'no',
    label: {
      en: 'Norwegian',
      de: 'Norwegisch',
    },
  },
  {
    id: 'da',
    label: {
      en: 'Danish',
      de: 'Dänisch',
    },
  },
  {
    id: 'cs',
    label: {
      en: 'Czech',
      de: 'Tschechisch',
    },
  },
  {
    id: 'hu',
    label: {
      en: 'Hungarian',
      de: 'Ungarisch',
    },
  },
  {
    id: 'ro',
    label: {
      en: 'Romanian',
      de: 'Rumänisch',
    },
  },
  {
    id: 'el',
    label: {
      en: 'Greek',
      de: 'Griechisch',
    },
  },
  {
    id: 'he',
    label: {
      en: 'Hebrew',
      de: 'Hebräisch',
    },
  },
  {
    id: 'id',
    label: {
      en: 'Indonesian',
      de: 'Indonesisch',
    },
  },
  {
    id: 'ms',
    label: {
      en: 'Malay',
      de: 'Malaiisch',
    },
  },
  {
    id: 'uk',
    label: {
      en: 'Ukrainian',
      de: 'Ukrainisch',
    },
  },
  {
    id: 'ta',
    label: {
      en: 'Tamil',
      de: 'Tamilisch',
    },
  },
  {
    id: 'fil',
    label: {
      en: 'Filipino',
      de: 'Filipino',
    },
  },
  {
    id: 'sk',
    label: {
      en: 'Slovak',
      de: 'Slowakisch',
    },
  },
  {
    id: 'sl',
    label: {
      en: 'Slovenian',
      de: 'Slowenisch',
    },
  },
  {
    id: 'et',
    label: {
      en: 'Estonian',
      de: 'Estnisch',
    },
  },
  {
    id: 'lt',
    label: {
      en: 'Lithuanian',
      de: 'Litauisch',
    },
  },
  {
    id: 'lv',
    label: {
      en: 'Latvian',
      de: 'Lettisch',
    },
  },
  {
    id: 'hr',
    label: {
      en: 'Croatian',
      de: 'Kroatisch',
    },
  },
  {
    id: 'sr',
    label: {
      en: 'Serbian',
      de: 'Serbisch',
    },
  },
  {
    id: 'bg',
    label: {
      en: 'Bulgarian',
      de: 'Bulgarisch',
    },
  },
  {
    id: 'fa',
    label: {
      en: 'Persian',
      de: 'Persisch',
    },
  },
  {
    id: 'am',
    label: {
      en: 'Amharic',
      de: 'Amharisch',
    },
  },
  {
    id: 'sw',
    label: {
      en: 'Swahili',
      de: 'Swahili',
    },
  },
  {
    id: 'yo',
    label: {
      en: 'Yoruba',
      de: 'Yoruba',
    },
  },
  {
    id: 'ig',
    label: {
      en: 'Igbo',
      de: 'Igbo',
    },
  },
  {
    id: 'ha',
    label: {
      en: 'Hausa',
      de: 'Hausa',
    },
  },
];
